import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SignInWithHR from './SignInWithHR';
import Dashboard from './Components/Dashboard';
import CreateCandidateAccount from './Components/CreateCandidateAccount';
import SignInWithCandidate from './SignInWithCandidate';
import SignUp from './SignUpWithHR';
import EnteryCandidatePortel from './Components/EnteryCandidatePortel';
import ViewCandidateAccount from './Components/ViewCandidateAccount';
import DisplayExitsCandidateDetails from './ExitsUsers/DisplayExitsCandidateDetails';
import SIgnInExitsCandidate from './ExitsUsers/SIgnInExitsCandidate';
import ThankYou from './Components/ThankYou';
import NotFound from './Components/PageNotFound';
import CandidateDetailPage from './Components/CandidateDetailPage';
import FullDetailsUsers from './ExitsUsers/FullDetailsUsers';
import AccessPage from './Components/AccessPage';
import AddTeam from './Components/AddTeam';
import AddRole from './Components/AddRole';
import ProfileView from './Components/ProfileView';
import ProfilePage from './NewEmployee/NewEmployeeProfile';
import NewProfileDetails from './NewEmployee/NewEmployeeProfile';
import FeedbackForm from './Components/Feedback';

const root = ReactDOM.createRoot(document.getElementById('root'));
const FirstPage = () => {
  const [userId, setUserId] = useState(null);
  // alert(userId)
  
  return  <React.StrictMode>
  <BrowserRouter>
    <Routes>
      {/* <Route exact path='/App' element={<App userId={userId}/>} /> */}
      {/* <Route exact path='/SignUpWithHR' element={<SignUpWithHR/>} /> */}
      <Route exact path='/SignInCandidate' element={<SignInWithCandidate userId={userId} setUserId={setUserId}/>} />
      <Route exact path='/' element={<SignInWithHR />} />
      <Route exact path='/SignUpWithHR' element={<SignUp />} />
      <Route exact path='/CreateCandidateAccount' element={<CreateCandidateAccount/>} />
      <Route path="/dashboard/*" element={<Dashboard/>} />
      <Route path="/EnteryCandidatePortel/*" element={<EnteryCandidatePortel userId={userId} setUserId={setUserId}/>} />
      <Route exact path='/ViewCandidateAccount' element={<ViewCandidateAccount/>} />
      <Route exact path='/DisplayExitsCandidateDetails' element={<DisplayExitsCandidateDetails/>} />
      <Route exact path='/SignInExitsCandidate' element={<SIgnInExitsCandidate/>} />
      <Route exact path='EnteryCandidatePortel/thank-you' element={<ThankYou/>} />
      <Route exact path='/*' element={<NotFound/>} />
      <Route path="/candidate/:userid" element={<CandidateDetailPage />} /> {/* Candidate details page */}
      <Route path="/ExitCandidate/:id" element={<FullDetailsUsers />} /> {/* Candidate details page */}
      <Route path="/Access" element={<AccessPage />} /> {/* Candidate details page */}
      <Route path="/Teams" element={<AddTeam />} /> {/* Candidate details page */}
      <Route path="/role" element={< AddRole/>} />
      <Route path="/profile" element={< ProfileView/>} />
      <Route path="/profileDetails" element={<NewProfileDetails />} />
      {/* <Route path="/feedback" element={<FeedbackForm />} /> */}
    </Routes>
  </BrowserRouter>
</React.StrictMode>
}

root.render(
  <FirstPage/>
);

reportWebVitals();
